import {
  Autocomplete,
  Chip,
  FormControl,
  Skeleton,
  TextField,
} from "@mui/material";
import { useIntl } from "react-intl";
import useGlobalContext from "globalProviders/GlobalDataProvider";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { CourseStatus, ResourceType } from "services/facultyPortalClient";

export type SelectMultipleFacultyTypeProps = {
  value?: string[];
  onChange: (value: string[]) => void;
  courseStatus?: CourseStatus;
};

export default function SelectMultipleFacultyType({
  value,
  onChange,
  courseStatus,
}: SelectMultipleFacultyTypeProps) {
  const { formatMessage: t } = useIntl();
  const { facultyTypeService } = useGlobalContext();

  const [options, setOptions] = useState<ResourceType[]>([]);

  const { data, isLoading, isFetching } = useQuery(
    ["facultyTypeService.getResourceTypesByUser", courseStatus],
    () => facultyTypeService.getResourceTypesByUser(courseStatus)
  );

  useEffect(() => {
    if (data) {
      setOptions(data.data ?? []);
    }
  }, [data]);

  const handleChangeMultiple = (_: any, values: ResourceType[]) => {
    onChange(values.map((v) => v.id!));
  };

  if (isFetching) {
    return <Skeleton variant="rectangular" height={40} />;
  }

  return (options?.length ?? 0) > 1 ? (
    <FormControl size="small" fullWidth>
      <Autocomplete
        multiple
        size="small"
        options={options}
        getOptionLabel={(option) => option.name ?? "?"}
        value={options.filter((r) => value?.includes(r.id!) ?? false)}
        onChange={handleChangeMultiple}
        loading={isLoading}
        renderInput={(params) => (
          <TextField {...params} label={t({ id: "facultyRole" })} />
        )}
        renderTags={(tagValue) =>
          tagValue.map((option, index) => (
            <Chip
              key={option.id}
              label={option.name}
              size="small"
              sx={{ mr: 0.5 }}
            />
          ))
        }
      />
    </FormControl>
  ) : null;
}
